import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Components
import AgeGateProtection from '@/components/AgeGateProtection'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

// Hooks
import { useTokenRefresh } from '@/hooks'

// Pages
import HomePage from '@/pages/HomePage'
import DiscoverPage from '@/pages/DiscoverPage'
import ContentPage from '@/pages/ContentPage'
import EpornerContentPage from '@/pages/EpornerContentPage'
import LetsJerktvContentPage from '@/pages/LetsJerktvContentPage'
import RedtubeContentPage from '@/pages/RedtubeContentPage'
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import UploadPage from '@/pages/UploadPage'
import ModerationPage from '@/pages/ModerationPage'
import AdminPage from '@/pages/AdminPage'
import Subscriptions from '@/pages/Subscriptions'
import SubscriptionSuccess from '@/pages/SubscriptionSuccess'
import SubscriptionCancel from '@/pages/SubscriptionCancel'
import InvoicesPage from '@/pages/InvoicesPage'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage'
import LegalNoticePage from '@/pages/LegalNoticePage'

// Styles
import './index.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  // Activer le rafraîchissement automatique du token JWT
  // Vérifie toutes les 60 secondes et rafraîchit 5 minutes avant expiration
  useTokenRefresh()

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <AgeGateProtection>
            <Navbar />
            <main className="main-content">
              <Routes>
                {/* Routes publiques (nécessitent la vérification d'âge) */}
                <Route path="/" element={<HomePage />} />
                <Route path="/categories" element={<DiscoverPage />} />
                <Route path="/content/eporner/:id" element={<EpornerContentPage />} />
                <Route path="/content/letsjerktv/:id" element={<LetsJerktvContentPage />} />
                <Route path="/content/redtube/:id" element={<RedtubeContentPage />} />
                <Route path="/content/:id" element={<ContentPage />} />
                
                {/* Routes d'authentification */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                
                {/* Routes protégées */}
                <Route path="/upload" element={<UploadPage />} />
                <Route path="/moderation" element={<ModerationPage />} />
                <Route path="/admin" element={<AdminPage />} />
                
                {/* Routes d'abonnements */}
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
                
                {/* Routes de facturation */}
                <Route path="/invoices" element={<InvoicesPage />} />
                
                {/* Routes légales */}
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/legal-notice" element={<LegalNoticePage />} />
                
                {/* Route par défaut */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </AgeGateProtection>
          
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
      </Router>
    </QueryClientProvider>
  )
}

export default App
